import { Command } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CmdIcon = createLucideIcon(Command);
